import { library } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Paragraph from 'Root/App/Paragraph'

import styles from './index.module.css'

export interface Props {
  value: string
}

library.add(faClipboardList)

const Note = ({ value }: Props) => (
  <div className={styles.wrapper}>
    <div>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon
          icon={['fas', 'clipboard-list']}
          transform={{ size: 20 }}
        />
      </div>
    </div>
    <div className="flex-grow text-left">
      <Paragraph>{value}</Paragraph>
    </div>
  </div>
)

export default Note
